"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const lodash_1 = require("lodash");
const lp_components_1 = require("lp-components");
const lp_form_1 = require("lp-form");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const redux_form_1 = require("redux-form");
const components_1 = require("components");
const config_1 = require("config");
const utils_1 = require("utils");
const reducer_1 = require("../../reducer");
function UserForm({ handleSubmit, allLocations, managerId, submitting, change, }) {
    const defaultPermissions = config_1.DEFAULT_PERMISSIONS_KEYS;
    const toggleCheckedAll = (hasAllPermissions) => {
        if (hasAllPermissions) {
            change('permissions', defaultPermissions);
        }
        else {
            change('permissions', []);
        }
    };
    const locationData = (0, react_1.useMemo)(() => {
        return (0, utils_1.locationOptionsWithLabels)(allLocations); // [...mockLocations()] as LocationType[] from utils
    }, [allLocations]);
    if (!locationData) {
        return;
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: "forms-container full-application__form", children: (0, jsx_runtime_1.jsxs)("form", { noValidate: true, onSubmit: handleSubmit, children: [(0, jsx_runtime_1.jsx)(redux_form_1.Field, { name: "firstName", component: lp_components_1.Input, placeholder: "First Name", label: "First Name", required: true, requiredIndicator: " *" }), (0, jsx_runtime_1.jsx)(redux_form_1.Field, { name: "lastName", component: lp_components_1.Input, placeholder: "Last Name", required: true, requiredIndicator: " *" }), (0, jsx_runtime_1.jsx)(redux_form_1.Field, { name: "email", component: lp_components_1.Input, required: true, requiredIndicator: " *", placeholder: "Email Address", type: "email" }), managerId && ((0, jsx_runtime_1.jsx)(redux_form_1.Field, { name: "assignNewPassword", component: lp_components_1.Checkbox, placeholder: "Assign New Password" })), (0, jsx_runtime_1.jsx)("div", { className: "radio-group", children: (0, jsx_runtime_1.jsx)("div", { className: "radio-group__share", children: (0, jsx_runtime_1.jsx)(redux_form_1.Field, { name: "status", label: "Active/Inactive:", component: lp_components_1.RadioGroup, placeholder: "Active/Inactive:", options: config_1.USER_STATUS }) }) }), (0, jsx_runtime_1.jsx)(redux_form_1.Field, { name: "assignedLocationIds", component: components_1.Select, label: "Locations", required: true, options: locationData, isMulti: true, closeMenuOnSelect: false, hideSelectedOptions: false, allowSelectAll: true, maxDisplay: 100 }), (0, jsx_runtime_1.jsx)("div", { className: "input-tips m-t-20 mb-3", children: (0, jsx_runtime_1.jsx)("p", { children: "You can choose multiple locations." }) }), (0, jsx_runtime_1.jsx)(redux_form_1.Field, { name: "adminPermissions", label: "Grant Admin Access", component: lp_components_1.CheckboxGroup, required: true, options: config_1.ADMIN_PERMISSION_OPTIONS }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)(lp_components_1.InputLabel, { label: "Permissions", required: true, requiredIndicator: "*" }), (0, jsx_runtime_1.jsx)(redux_form_1.Field, { name: "selectAllPermissions", className: "select-all-permissions-checkbox", label: "Select all permissions", component: lp_components_1.Checkbox, onChange: toggleCheckedAll }), (0, jsx_runtime_1.jsx)(redux_form_1.Field, { name: "permissions", label: false, component: lp_components_1.CheckboxGroup, required: true, options: config_1.PERMISSION_OPTIONS }), (0, jsx_runtime_1.jsxs)("div", { className: "start-application__form--actions m-t-50 m-b-50", children: [(0, jsx_runtime_1.jsx)("div", { className: "submit", children: (0, jsx_runtime_1.jsx)(lp_components_1.SubmitButton, { className: `button-warn-outline`, disabled: submitting, submitting: submitting, children: managerId ? 'SAVE CHANGES' : 'SUBMIT' }) }), (0, jsx_runtime_1.jsx)("div", { className: "cancel", children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: config_1.USER_URL, children: "CANCEL" }) })] })] }) }));
}
function mapStateToProps(state) {
    return {
        allLocations: reducer_1.selectors.allLocations(state),
    };
}
function beforeSubmit(userFormData) {
    const { adminPermissions, permissions: formPermissions } = userFormData;
    let permissions = formPermissions;
    if (!(0, lodash_1.isEmpty)(adminPermissions)) {
        permissions = [...formPermissions, ...adminPermissions];
    }
    return {
        ...userFormData,
        permissions,
    };
}
exports.default = (0, redux_1.compose)((0, lp_form_1.lpForm)({
    beforeSubmit,
    name: 'userForm',
    enableReinitialize: true,
    constraints: {
        firstName: {
            presence: true,
        },
        lastName: {
            presence: true,
        },
        email: { presence: true, email: true },
        permissions: { presence: true },
        assignedLocationIds: { presence: true },
    },
    submitFilters: { reject: ['adminPermissions', 'selectAllPermissions'] },
}), (0, redux_form_1.formValues)({
    managerId: 'managerId',
}), (0, react_redux_1.connect)(mapStateToProps))(UserForm);
